<template>
  <div>
    <content-loader
      v-if="isLoading"
      :speed="6"
      :animate="true"
      primaryColor="#262d3c"
      secondaryColor="#384257"
    >
      <rect x="10" y="15" rx="2" ry="2" width="300" height="5" />
      <rect x="10" y="25" rx="2" ry="2" width="220" height="5" />

      <rect x="10" y="35" rx="2" ry="2" width="300" height="5" />
      <rect x="10" y="45" rx="2" ry="2" width="220" height="5" />

      <rect x="10" y="55" rx="2" ry="2" width="300" height="5" />
      <rect x="10" y="65" rx="2" ry="2" width="220" height="5" />

      <rect x="10" y="75" rx="2" ry="2" width="300" height="5" />
      <rect x="10" y="85" rx="2" ry="2" width="220" height="5" />

      <rect x="10" y="95" rx="2" ry="2" width="300" height="5" />
      <rect x="10" y="105" rx="2" ry="2" width="220" height="5" />
    </content-loader>

    <section v-else>
      <div
        v-for="(week, weekIndex) in tableData"
        v-bind:key="`week_${weekIndex}`"
        class="col-12 weekTable"
        :class="`week_${employee.id}`"
      >
        <div class="card">
          <div class="card-header bg-teal-400 d-flex justify-content-between">
            {{ week.week[0] }} - {{ week.week[week.week.length - 1] }}
          </div>
          <div class="card-body">
            <table id="tableData" class="table table-striped">
              <tr>
                <th></th>
                <th
                  v-for="(date, index) in week.week"
                  v-bind:key="`date1_${index}`"
                >
                  {{ date }}
                </th>
                <th></th>
              </tr>
              <tr>
                <td>
                  <strong>Regular Hours</strong>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`regular1_${index}`"
                >
                  <strong>{{ timeCard.regularHours }}</strong>
                </td>
                <td>
                  <strong>{{ totals[weekIndex].regularTotal }}</strong>
                </td>
              </tr>
              <template v-if="jobSpecificTimes">
                <tr
                  v-for="(value, name, index) in jobSpecificTotals[weekIndex]
                    .regular"
                  :key="`jstreg_${index}`"
                  class="jobTimes"
                >
                  <td class="text-center">
                    {{ getJobName(name) }}
                  </td>
                  <td
                    v-for="(timeCard, index) in week.timeCards"
                    v-bind:key="`job1_${index}`"
                  >
                    {{
                      timeCard.jobSpecificHoursSummary
                        ? timeCard.jobSpecificHoursSummary.regular[`${name}`]
                          ? timeCard.jobSpecificHoursSummary.regular[`${name}`]
                          : 0
                        : 0
                    }}
                  </td>
                  <td>{{ value }}</td>
                </tr>
              </template>
              <tr>
                <td>
                  <strong>OT Hours</strong>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`ot1_${index}`"
                >
                  <strong>{{ timeCard.otHours }}</strong>
                </td>
                <td>
                  <strong>{{ totals[weekIndex].otTotal }}</strong>
                </td>
              </tr>
              <template v-if="jobSpecificTimes">
                <tr
                  v-for="(value, name, index) in jobSpecificTotals[weekIndex]
                    .ot"
                  :key="`jstot_${index}`"
                  class="jobTimes"
                >
                  <td class="text-center">{{ getJobName(name) }}</td>
                  <td
                    v-for="(timeCard, index) in week.timeCards"
                    v-bind:key="`job2_${index}`"
                  >
                    {{
                      timeCard.jobSpecificHoursSummary
                        ? timeCard.jobSpecificHoursSummary.ot[`${name}`]
                          ? timeCard.jobSpecificHoursSummary.ot[`${name}`]
                          : 0
                        : 0
                    }}
                  </td>
                  <td>{{ value }}</td>
                </tr>
              </template>
              <tr v-show="totals[weekIndex].travelTimeTotal > 0">
                <td>
                  <strong>Travel Time</strong>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`travel1_${index}`"
                >
                  <strong>{{ timeCard.travelTime }}</strong>
                </td>
                <td>
                  <strong>{{ totals[weekIndex].travelTimeTotal }}</strong>
                </td>
              </tr>
              <tr v-show="totals[weekIndex].onCallHoursTotal > 0">
                <td>
                  <strong>On Call Time</strong>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`travel1_${index}`"
                >
                  <strong>{{ timeCard.onCallHours }}</strong>
                </td>
                <td>
                  <strong>{{ totals[weekIndex].onCallHoursTotal }}</strong>
                </td>
              </tr>
              <tr v-show="totals[weekIndex].statTotal > 0">
                <td>
                  <strong>Stat Pay</strong>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`stat1_${index}`"
                >
                  <strong>{{ timeCard.statTime }}</strong>
                </td>
                <td>
                  <strong>{{ totals[weekIndex].statTotal }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Total Hours</strong>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`total1_${index}`"
                >
                  <strong>{{ timeCard.totalHours }}</strong>
                </td>
                <td>
                  <strong>{{ totals[weekIndex].total }}</strong>
                </td>
              </tr>
              <!-- new -->
              <tr>
                <td>
                  <el-button
                    type="primary"
                    size="mini"
                    v-on:click="showTimeCardDetails = !showTimeCardDetails"
                  >
                    Show Timecard Details <i class="el-icon-arrow-down"></i>
                  </el-button>
                </td>
                <td
                  v-for="(timeCard, index) in week.timeCards"
                  v-bind:key="`times1_${index}`"
                >
                  <div
                    v-for="(time, time_index) in timeCard.times"
                    v-bind:key="`timeLoop_${time_index}`"
                    v-show="showTimeCardDetails"
                  >
                    {{ time.startTime }} - {{ time.endTime }}
                    <el-tooltip
                      v-show="
                        time.notes != undefined &&
                          time.notes != null &&
                          time.notes.trim() != ''
                      "
                      class="item ml-1"
                      effect="dark"
                      placement="top"
                      data-html="true"
                    >
                      <div slot="content" v-html="time.notes"></div>
                      <i class="icon-bubble"></i>
                    </el-tooltip>
                  </div>
                  <span
                    class="badge badge-warning mt-2 cursor-pointer"
                    v-if="timeCard.comments != null && showTimeCardDetails"
                    v-on:click="showCommentModal(timeCard.comments)"
                  >
                    View time card notes
                  </span>
                </td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </section>
    <el-dialog
      title="Notes"
      :visible.sync="showComment"
      width="30%"
      custom-class="confirmModal commentsModal scroll_dialog"
      :show-close="true"
      height="5%"
    >
      <div
        v-for="(comment, index) in tempComments"
        v-bind:key="index"
        v-bind:class="
          comment.commentBy == storedUser ? 'float-right' : 'float-left'
        "
      >
        <div
          class="mb-2 d-inline-grid text-left "
          v-bind:class="
            comment.commentBy == storedUser
              ? 'float-right speech-bubble-mine'
              : 'float-left speech-bubble'
          "
        >
          <span>
            <strong> {{ comment.commentBy }}:</strong>
          </span>
          <!-- <span> {{ comment.commentDate }} </span> -->
          <p class="mt-2">
            {{ comment.comment }}
          </p>
        </div>
      </div>
    </el-dialog>
    <report-calculations
      v-if="timeCardCollection.length > 0"
      :timeCardCollection="timeCardCollection"
      :employee="employee"
      :searchDate="searchDate"
      :holidays="holidays"
      :holidaysInTimeSpan="holidaysInTimeSpan"
      @updateData="updateData"
      @updateStatTotals="updateStatTotals"
      @updateStatCards="updateStatCards"
      style="display: none"
    ></report-calculations>
  </div>
</template>

<script>
import reportCalculations from '../childComponents/reportCalculations.vue';
import { ContentLoader } from 'vue-content-loader';
import { db } from '../../assets/js/firebase/db.js';
import moment from 'moment';
import { getHolidays } from '../../assets/js/helpers/holidays.js';
import { roundToQuarter } from '../../assets/js/helpers/hoursCalculations.js';
import { getWeeksFromDateRange } from '../../assets/js/helpers/dates.js';

export default {
  name: 'payrollReportTablev2',
  components: {
    ContentLoader,
    reportCalculations
  },
  data() {
    return {
      tableData: null,
      totals: [],
      jobSpecificTotals: [],
      holidays: [],
      holidaysInTimeSpan: [],
      timeCardCollection: [],
      isLoading: null,
      statDaysWorked: null,
      statHoursWorked: null,
      statExemptDays: null,
      statExemptHours: null,
      statTime: null,
      statTimeCards: [],
      showTimeCardDetails: false,
      showComment: false,
      tempComments: [],
      missingTimeCardError: false,
      missingTimeCardMessage: null,
      duplicateTimeCardErrors: []
    };
  },
  props: {
    employee: Object,
    searchDate: Array
  },
  methods: {
    calculateEmployee: async function() {
      //clear the totals.
      this.$store.commit('clearTotals');
      this.timeCardCollection = [];
      this.tableData = [];
      this.holidays = [];
      this.holidaysInTimeSpan = [];
      this.isLoading = true;

      //need to split the date range into weeks, so we can do weekly OT calculations.
      let weeks = getWeeksFromDateRange(this.searchDate[0], this.searchDate[1]);
      //get holidays and calculate holidays in the time span selected
      await this.getHolidays(this.searchDate[0], this.searchDate[1]);
      this.calculateHolidays();

      //get timecards, as they are added to the timecard collection they will be passed to the reportCalculations component
      for (let week of weeks) {
        this.getTimeCards(
          moment(week.startOfWeek).startOf('day'),
          moment(week.endOfWeek).endOf('day')
        );
      }
    },
    getTimeCards: async function(startDate, endDate) {
      try {
        //run out to the store and grab a pack of time cards.
        let querySnapshot = await db
          .collection('timeCards')
          .where('date', '>=', new Date(startDate))
          .where('date', '<=', new Date(endDate))
          .where('user', '==', this.employee.id)
          .where('company', '==', this.$store.state.userCompany)
          .orderBy('date', 'asc')
          .get();
        let tempArg = { timeCards: [] };
        let holidayWeek = false;
        let holidayDate = null;
        let employeeWorkedHoliday = false;
        this.holidaysInTimeSpan.forEach(holiday => {
          if (moment(holiday).isBetween(startDate, endDate, undefined, '[]')) {
            holidayWeek = true;
            holidayDate = holiday;
          }
        });
        querySnapshot.forEach(doc => {
          //check if employee worked holiday
          let date = moment(doc.data().date.toDate()).format('MMM DD, YY');
          if (this.holidaysInTimeSpan.includes(date)) {
            employeeWorkedHoliday = true;
          }
          //check if all timecards are complete
          let complete = true;
          for (let i = 0; i <= doc.data().times.length - 1; i++) {
            if (doc.data().times[i].endTime == null) {
              complete = false;
            }
          }
          if (complete) {
            if (doc.data().approved == false) {
              //there are time cards that are not approved in this time frame.
              this.missingTimeCardError = true;
              this.missingTimeCardMessage =
                'There are time cards in the selected time frame that are not approved.';
            } else {
              //only going to display time cards that have an end time and that are approved.
              tempArg.timeCards.push({
                id: doc.id,
                date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                times: doc.data().times,
                approved: doc.data().approved,
                approvedBy:
                  doc.data().approvedBy === undefined
                    ? null
                    : doc.data().approvedBy,
                name: doc.data().name,
                type: doc.data().type,
                dateApproved:
                  doc.data().dateApproved === undefined
                    ? null
                    : moment(doc.data().dateApproved.toDate()).format(
                        'MMM DD, YY hh:mm'
                      ),
                vacation: doc.data().vacation,
                uid: doc.data().user,
                averagingAgreement: doc.data().averagingAgreement
                  ? doc.data().averagingAgreement
                  : null,
                editComment: doc.data().editComment
              });
            }
          } else {
            //there are incomplete time cards.
            this.missingTimeCardError = true;
            this.missingTimeCardMessage =
              'There are ongoing time cards in the selected time frame.';
          }
        });
        let sum = 0;
        let index = -1;
        let lastHours = 0;
        let dayAdd = 0;

        if (holidayWeek && !employeeWorkedHoliday) {
          tempArg.timeCards.push({
            id: `${this.employee.id}-${holidayDate}`,
            date: holidayDate,
            times: [
              {
                startTime: moment(holidayDate).startOf('day'),
                endTime: moment(holidayDate).startOf('day'),
                type: 'regular'
              }
            ],
            approved: true,
            approvedBy: 'holiday',
            name: this.employee.name,
            type: this.employee.type,
            dateApproved: holidayDate,
            vacation: 'null',
            uid: this.employee.id
          });
        }

        //sort the time cards by date because we possibly added a time card for the holiday at the end of the array.
        tempArg.timeCards.sort(function(a, b) {
          return new Date(a.date) - new Date(b.date);
        });

        for (let i = 0; i <= tempArg.timeCards.length - 1; i++) {
          //iterate all of the times to get a total.
          let daysum = 0;
          for (let t = 0; t <= tempArg.timeCards[i].times.length - 1; t++) {
            tempArg.timeCards[i].times[t] = {
              times: [
                tempArg.timeCards[i].times[t].startTime.toDate(),
                tempArg.timeCards[i].times[t].endTime.toDate()
              ],
              type: tempArg.timeCards[i].times[t].type,
              job: tempArg.timeCards[i].times[t].job
                ? tempArg.timeCards[i].times[t].job
                : null,
              notes: tempArg.timeCards[i].times[t].notes
            };
            let start = moment(tempArg.timeCards[i].times[t].times[0]);
            let end = moment(tempArg.timeCards[i].times[t].times[1]);
            if (
              !this.holidays.includes(
                moment(tempArg.timeCards[i].date).format('YYYY-MM-DD')
              )
            ) {
              daysum += Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
            }
            if (
              tempArg.timeCards[i].times[t].type == 'travel time' ||
              tempArg.timeCards[i].times[t].type == 'on call' ||
              tempArg.timeCards[i].times[t].type == 'ot exempt'
            ) {
              //the travel time and on call times need to be removed from the weekly ot count.
              daysum -= Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
            }
          }
          if (tempArg.timeCards[i].type == 'employee') {
            if (roundToQuarter(daysum) >= 8) {
              sum += 8;
              dayAdd = 8;
            } else {
              sum += Number(roundToQuarter(Number(daysum)));
              dayAdd = Number(roundToQuarter(Number(daysum)));
            }

            if (sum >= 44 && index == -1) {
              //x = o-(s-c)
              //x = the regular time that is applied to reach the total of 44 hours worked in a work week.
              //o = the weekly ot maximum.
              //s = weekly sum
              //c = current day's regular hours that would be applied to the sum
              lastHours = 44 - (sum - dayAdd);
              index = i;
            }
          } else if (tempArg.timeCards[i].type == 'driver') {                      
            if (Number(roundToQuarter(Number(daysum))) >= 10) {
              sum += 10;
              dayAdd = 10;
            } else {
              sum += Number(roundToQuarter(Number(daysum)));
              dayAdd = Number(roundToQuarter(Number(daysum)));
            }  

            if (sum >= 50 && index == -1) {
              lastHours = 50 - (sum - dayAdd);
              index = i;
            }
          }
        }
        //this is the time card that will go over the weekly maximum
        if (index !== -1) {
          for (let i = index; i < tempArg.timeCards.length; i++) {
            tempArg.timeCards[i].lastRegTime = lastHours;
            tempArg.timeCards[i].otIndex = index;
          }
        }

        //before we push the array, look to see if there are more than one timecard for a day. If there is, display the alert
        let dateArray = tempArg.timeCards.map(function(item) {
          return item.date;
        }); //create a new array that is just the dates.
        var isDuplicate = dateArray.some(function(item, idx) {
          return dateArray.indexOf(item) != idx; //check if the date exists in the array that isn't the current index.
        });

        if (isDuplicate) {
          //there are incomplete time cards.
          this.duplicateTimeCardErrors.push({
            error: true,
            message: `WARNING: ${
              tempArg.timeCards[0].name
            } has more than one time card on the same day during the week of ${moment(
              startDate
            ).format('MMM DD, YY')} - ${moment(endDate).format(
              'MMM DD, YY'
            )} the Payroll Report may not accurately reflect the user's hours worked.`
          });
        } else {
          //there are incomplete time cards.
          this.duplicateTimeCardErrors.push({
            error: false,
            message: null
          });
        }

        //push to the timecard collection, which will be sent to the reportCalculations component
        this.timeCardCollection.push(tempArg);
      } catch (err) {
        console.log(err);
      }
    },
    //updateData is emitted from the reportCalculations component upon completion
    updateData: function(
      totals,
      data,
      employee,
      hoursWorkedTotals,
      jobSpecificTotals
    ) {
      /*statTimeCards is a list of all statTimeCards in the report, we get it from the reportCalculations component
       when it emits updateStatCards, now we iterate over it to add the time to the data and the totals*/
      if (this.statTimeCards.length > 0) {
        this.statTimeCards.forEach(stat => {
          data.forEach((x, index) => {
            x.timeCards.forEach(card => {
              if (stat.date === card.date) {
                if (!isNaN(stat.val) && card.calculated !== true) {
                  card.calculated = true;
                  card.statTime = stat.val;
                  totals[index].statTotal =
                    Number(totals[index].statTotal) + Number(stat.val);
                }
              }
            });
          });
        });
      }
      this.totals = totals;
      this.jobSpecificTotals = jobSpecificTotals;
      this.tableData = data;
      //emit the data up to payrollReport so it can display totals at the top
      this.$emit(
        'updateTotals',
        this.totals,
        data,
        this.employee,
        this.missingTimeCardError,
        this.missingTimeCardMessage,
        this.duplicateTimeCardErrors,
        this.jobSpecificTotals
      );
      this.isLoading = false;
    },
    //updateStatTotals is emitted from the reportCalculations component when a stat timecard is loaded
    updateStatTotals: function(
      multipleStats,
      statHoursWorked,
      statDaysWorked,
      statExemptDays,
      statExemptHours,
      statError
    ) {
      this.$emit(
        'updateStatTotals',
        multipleStats,
        statHoursWorked,
        statDaysWorked,
        statExemptDays,
        statExemptHours,
        statError
      );
    },
    showCommentModal: function(comments) {
      this.showComment = true;
      this.tempComments = comments;
    },
    //updateStatCards is emitted from reportCalculations every time a stat timecard is loaded,
    //  the original emit is from the timecard component
    updateStatCards: function(val, index, date, uid) {
      if (!this.statTimeCards.some(e => e.date === date)) {
        this.statTimeCards.push({ date: date, index: index, val: val });
      }
      if (this.tableData.length > 0) {
        this.statTimeCards.forEach(stat => {
          this.tableData.forEach((x, index) => {
            x.timeCards.forEach(card => {
              if (stat.date === card.date) {
                if (!isNaN(stat.val) && card.calculated !== true) {
                  card.calculated = true;
                  card.statTime = stat.val;
                  this.totals[index].statTotal =
                    Number(this.totals[index].statTotal) + Number(stat.val);
                }
              }
            });
          });
        });
      }
    },

    getHolidays: async function(startDate, endDate) {
      this.holidays = [];
      let startYear = Number(moment(startDate).format('YYYY'));
      let numberOfYears =
        Number(moment(endDate).format('YYYY')) -
        Number(moment(startDate).format('YYYY'));
      //get the list of holidays for the year that the user has selected.
      for (let i = 0; i <= numberOfYears; i++) {
        try {
          let response = await getHolidays(startYear.toString());
          for (
            let i = 0;
            i <= response.data.provinces[0].holidays.length - 1;
            i++
          ) {
            this.holidays.push(response.data.provinces[0].holidays[i].date);
          }
        } catch (err) {
          console.log(`Error getting holidays ${err}`);
        }
        startYear++;
      }
    },
    calculateHolidays: function() {
      //add all holidays in the time span selected to an array
      this.holidaysInTimeSpan = [];
      this.holidays.forEach(holiday => {
        if (
          moment(holiday).isBetween(
            this.searchDate[0],
            this.searchDate[1],
            undefined,
            '[]'
          )
        ) {
          holiday = moment(holiday).format('MMM DD, YY');
          if (!this.holidaysInTimeSpan.includes(holiday)) {
            this.holidaysInTimeSpan.push(holiday);
          }
        }
      });
    },
    getJobName(id) {
      if (id && id !== 'default') {
        let job = this.jobs.find(x => x.id === id);
        return job.description;
      }
      return 'Unassigned';
    }
  },
  computed: {
    storedUser: function() {
      return this.$store.state.userName;
    },
    jobSpecificTimes() {
      return this.$store.state.jobSpecificTimes;
    },
    jobs() {
      return this.$store.state.jobs;
    }
  },
  mounted() {
    this.calculateEmployee();
  }
};
</script>
